import { combineReducers } from 'redux';
import authReducer from './authReducer';
import adminReducer from './adminReducer';
import snackBarReducer from './snackBarReducer';

export const rootReducer = combineReducers({
    authReducer,
    adminReducer,
    snackBarReducer
})